/******
 * B1 Yönetim Sistemleri Yazılım ve Danışmanlık Limited Şirketi
 * B1 Digitial
 * http://www.b1.com.tr
 *
 * translate.model Information
 *
 *
 * Date      : 2019-10-15
 * Time      : 11:57
 * Developer : ibrahimcobani
 *
 *******/
export class TranslateModel {
  tr: string;
  en: string;
  de: string;
  fr: string;
  ru: string;
  ar: string;
  fa: string;
  es: string;

  constructor(tr = '',
              en = '',
              de = '',
              fr = '',
              ru = '',
              ar = '',
              fa = '',
              es = '') {
    this.tr = tr;
    this.en = en;
    this.de = de;
    this.fr = fr;
    this.ru = ru;
    this.ar = ar;
    this.fa = fa;
    this.es = es;
  }
}
